import React from 'react';

// Import images
import b2bApp from "../../assets/img/features/b2b-app.png";
import announceGif from "../../assets/img/announce.gif";
import Footer from '../../Components/Footer';
import Header from '../../Components/Header';

const SmartB2B = () => {
  return (
    <div>
        <Header/>
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <div className="container text-center py-5" style={{ maxWidth: '900px' }}>
          <h4 className="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">Smart B2B Procurement App</h4>
          <ol className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
            <li className="breadcrumb-item">
              <a href="#">Home</a>
            </li>
            <li className="breadcrumb-item active text-primary">Smart B2B Procurement App</li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* B2B Feature Start */}
      <section className="bg-white p-50">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-5 col-lg-5">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src={b2bApp}
                    className="img-fluid rounded w-45"
                    alt="b2b Smart App"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-7 col-lg-7">
              <h1 className="text-left mb-4">Effortless Ordering & Transparency for Business Vendors</h1>
              <p className="text-left font-size-p">
                Managing inventory and ordering stock for businesses has never been easier! Our B2B mobile application empowers business vendors, purchase managers, store owners, and distributors by providing a seamless end-to-end procurement workflow. Designed to enhance transparency, efficiency, and control, our solution ensures a hassle-free ordering experience while reducing manual errors and delays.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* B2B Feature End */}

      {/* Key Features & Benefits Section */}
      <div className="container py-5">
        <h1 className="text-center">Key Features & Benefits</h1>
        <div className="row g-4">
          <div className="col-md-12">
            <h3>Simplified Purchase Management</h3>
            <ul>
              <li><span className="icon-box"></span> Purchase Managers can easily browse products, place orders, and track status in real-time.</li>
              <li><span className="icon-box"></span> Smart Reordering based on demand forecasts and stock levels.</li>
              <li><span className="icon-box"></span> Customizable Approval Workflows for seamless order authorization.</li>
              <li><span className="icon-box"></span> Real-Time Order Approvals & Notifications</li>
            </ul>
          </div>
        </div>

        <div className="text-left mt-5">
          <h3>Real-Time Order Approvals & Notifications</h3>
          <ul className="list-unstyled">
            <li><span className="icon-box"></span> Store Owners receive instant notifications for order approvals.</li>
            <li><span className="icon-box"></span> One-click approval or modifications for better control over purchases.</li>
            <li><span className="icon-box"></span> AI-powered order insights to optimize inventory planning.</li>
          </ul>
        </div>

        <div className="text-left mt-5">
          <h3>Distributor Fulfillment & Logistics</h3>
          <ul className="list-unstyled">
            <li><span className="icon-box"></span> Distributors get instant alerts for new orders and fulfillment requests.</li>
            <li><span className="icon-box"></span> Real-time order tracking & delivery status updates.</li>
            <li><span className="icon-box"></span> Seamless invoicing & payment integration for faster transactions.</li>
          </ul>
        </div>

        {/* Call to Action Section */}
        <h4 className="mt-4">
          <img src={announceGif} className="w-50px" alt="announcement" /> Ready to Scale Your Business?
        </h4>
        <p className="font-size-p">
          Let’s build the future of eCommerce with intelligent automation, seamless integrations, and AI-driven insights.
        </p>
        <div className="row g-4 mb-5">
          <div className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.2s">
            <div className="contact-add-item">
              <div className="contact-icon text-primary mb-4">
                <i className="fas fa-map-marker-alt fa-2x"></i>
              </div>
              <div>
                <h4>Website</h4>
                <p className="mb-0">
                  <a href="https://epic-x.io/">epic-x.io</a>
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.4s">
            <div className="contact-add-item">
              <div className="contact-icon text-primary mb-4">
                <i className="fas fa-envelope fa-2x"></i>
              </div>
              <div>
                <h4>Mail Us</h4>
                <p className="mb-0">techsupport@epic-x.io</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.6s">
            <div className="contact-add-item">
              <div className="contact-icon text-primary mb-4">
                <i className="fa fa-phone-alt fa-2x"></i>
              </div>
              <div>
                <h4>Call Us</h4>
                <p className="mb-0">+91-8925696660</p>
              </div>
            </div>
          </div>
        </div>
        <h4>Empower your business with scalable, intelligent, and future-ready B2C solutions today! 🚀</h4>
      </div>
      <Footer/>
    </div>
  );
};

export default SmartB2B;